import {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {Box, Flex} from '@chakra-ui/react';
import Latex from 'react-latex-next';
import {hasValue} from '@progress-fe/core';
import {Svg, ISimpleTableColumnTarget} from '@progress-fe/ui-kit';
import {TProjectDatasetModel} from 'stores/TechProcessStore';

interface IProps {
  datasetInstance: TProjectDatasetModel;
  item: ISimpleTableColumnTarget;
  onClick: () => void;
}

const HeaderRendererFC: FC<IProps> = ({item, datasetInstance, onClick}) => {
  const hasColumnRelation = (propertyName: string | undefined) => {
    return (
      hasValue(propertyName) &&
      datasetInstance.datasetRelations.some((r) => r.columnName === propertyName)
    );
  };

  return (
    <Flex gap={'6px'} alignItems={'center'} onClick={onClick} _hover={{cursor: 'pointer'}}>
      <Latex>{item.name}</Latex>
      <Box opacity={hasColumnRelation(item.propertyName) ? 1 : 0.4}>
        <Svg name={'Link'} />
      </Box>
    </Flex>
  );
};

export const HeaderRenderer = observer(HeaderRendererFC);
